import * as React from "react";
import MuiCheckbox from "@material-ui/core/Checkbox";
import type { UiBaseProps } from "../uiProps.utils";

export type CheckboxProps = Omit<UiBaseProps, "children"> & {
  checked: boolean;
  onChange?: (checked: boolean) => void;
  disabled?: boolean;
};

// Orange when ticked, the app's action colour. id and aria-* go on the input itself, so they name the checkbox.
export const Checkbox: React.FC<CheckboxProps> = ({ checked, onChange, disabled, className, style, ...input }) => (
  <MuiCheckbox
    color="primary"
    checked={checked}
    onChange={onChange ? (event) => onChange(event.target.checked) : undefined}
    disabled={disabled}
    className={className}
    style={style}
    inputProps={input as React.InputHTMLAttributes<HTMLInputElement>}
  />
);
